import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useSelector } from 'react-redux'
import { navbarMenuItems, headerFilters } from 'utils/constants'

const HeaderSkeleton = () => {
  const { activeChatTheme } = useSelector((state) => state.theme)
  const isDark = activeChatTheme !== 'theme5'

  return (
    <div
      className={`header fixed left-0 top-0 w-full z-[998] transition-all duration-300 shadow-md backdrop-blur-lg ${
        isDark ? '!bg-black/95' : 'bg-white/95'
      }`}
    >
      <div className="flex items-center justify-between py-3 px-4 lg:px-6 xl:px-8 h-[64px] capitalize">
        {/* Logo and Navigation */}
        <div className="flex items-center gap-3 md:gap-8 w-1/4 md:w-[25%] min-w-max lg:w-[18%] 2xl:w-[22%]">
          <Link className="text-center text-sm font-semibold tracking-[0.14px]" href="/">
            <div className="inline-flex justify-end items-center logo h-[32px] shrink-0">
              <Image
                src="/assets/common/StyleyLogo.png"
                alt="Styley Logo"
                width={90}
                height={35}
                priority
                className={`object-contain h-[35px] w-auto ${isDark ? '!invert' : ''}`}
              />
            </div>
          </Link>
          <div className="hidden md:flex items-center space-x-1 lg:space-x-3 2xl:space-x-6">
            {navbarMenuItems.map((item, index) => (
              <div
                key={`skeleton-menu-${index}`}
                className={`h-6 w-16 rounded animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}
              ></div>
            ))}
          </div>
        </div>

        {/* Centered Search Bar */}
        <div className="searchbar xl:w-[28%] lg:w-[25%] 2xl:w-[30%] h-[44px] flex-shrink-0 hidden md:block lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2">
          <div className={`h-[44px] rounded-full animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}></div>
        </div>

        {/* Right Side - Loading skeleton */}
        <div className="flex gap-2 w-[30%] justify-end">
          <div className={`h-9 w-20 rounded animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}></div>
          <div className={`h-9 w-16 rounded animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}></div>
        </div>
      </div>

      {/* Filter Navigation Skeleton */}
      <div
        className="w-full hidden md:flex justify-center items-center border-b border-white/10"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.85), rgba(0,0,0,0.75))',
          backdropFilter: 'blur(12px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        }}
      >
        <div className="flex justify-center items-center gap-6 md:gap-8 lg:gap-10 py-2 overflow-x-auto">
          {headerFilters.slice(0, 6).map((_, i) => (
            <div key={`skeleton-filter-${i}`} className="h-4 w-12 bg-white/20 rounded animate-pulse"></div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HeaderSkeleton
